/**
 * Utility functions for detecting USezpay domains
 */

/**
 * Check if a domain is a USezpay domain
 * Simply checks if the URL contains "usezpay" (case-insensitive)
 * @param {string} domain - The domain to check
 * @returns {boolean} - True if it's a USezpay domain
 */
export function isUSezpayDomain(domain) {
    if (!domain) return false;

    // Simply check if the domain contains "usezpay" (case-insensitive)
    // This catches all USezpay domains: usezpaydev.com, merchant.usezpaydev.com,
    // usezpayclouddev.com, api.usezpaycloud.com, etc.
    return domain.toLowerCase().includes('usezpay');
}

/**
 * Check if the redirect_uri or referrer is from a USezpay domain
 * @returns {boolean} - True if request is from USezpay
 */
export function isUSezpayRequest() {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUri = urlParams.get('redirect_uri');

    if (redirectUri && isUSezpayDomain(redirectUri)) {
        console.log('🔧 Domain Detection - USezpay redirect_uri detected:', redirectUri);
        return true;
    }

    const referrer = document.referrer;
    if (referrer && isUSezpayDomain(referrer)) {
        console.log('🔧 Domain Detection - USezpay referrer detected:', referrer);
        return true;
    }

    const currentHostname = window.location.hostname;
    if (isUSezpayDomain(currentHostname)) {
        console.log('🔧 Domain Detection - USezpay hostname detected:', currentHostname);
        return true;
    }

    console.log('🔧 Domain Detection - Not a USezpay request');
    return false;
}
